<template>
  <div
    class="platform-mobile-top-bar"
    :style="{ backgroundColor: primaryColor }"
    data-qa="platform-mobile-top-bar"
  >
    <button
      class="platform-mobile-top-bar__profile"
      data-qa="profile-button"
      @click="$emit('profile-click')"
    >
      <VcAvatar
        :imagePath="profileDetails.imagePath"
        :colorId="profileDetails.colorId"
        :name="profileDetails.displayName"
        size="sm"
      />
    </button>

    <div class="platform-mobile-top-bar__actions">
      <button
        v-if="showAiChat"
        class="platform-mobile-top-bar__action-btn"
        data-qa="ai-chat-button"
        @click="$emit('ai-chat-click')"
      >
        <VcIcon class="platform-mobile-top-bar__ai-icon" size="20" :color="textColor">icon-AI-logo</VcIcon>
      </button>

      <button
        class="platform-mobile-top-bar__action-btn"
        data-qa="search-button"
        @click="$emit('search-click')"
      >
        <VcIcon size="16" :color="textColor">$magnify_glass</VcIcon>
      </button>

      <button
        class="platform-mobile-top-bar__action-btn"
        data-qa="notifications-button"
        @click="$emit('notifications-click')"
      >
        <VcBadge :badgeText="notificationsBadge" :offset-y="4" :offset-x="4" size="sm">
          <VcIcon size="20" :color="textColor">$notifications</VcIcon>
        </VcBadge>
      </button>

    </div>
  </div>
</template>

<script>
export default {
  name: 'PlatformMobileTopBar',
  props: {
    primaryColor: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: 'white',
    },
    profileDetails: {
      type: Object,
      default: () => ({ imagePath: '', colorId: 27, displayName: '' }),
    },
    notificationsBadge: {
      type: [String, Number],
      default: 0,
    },
    showAiChat: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.platform-mobile-top-bar {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--size-value4);
  padding-top: var(--safe-area-inset-top);
  height: calc(var(--vc-top-bar-height) + var(--safe-area-inset-top));
  min-height: calc(var(--vc-top-bar-height) + var(--safe-area-inset-top));

  &__profile {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: var(--size-value3);
  }

  &__ai-icon {
    width: 20px;
    height: 20px;
  }

  &__action-btn {
    background: none;
    border: none;
    padding: 0;
    width: 32px;
    height: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: relative;
    overflow: visible;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }
}
</style>
